import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
let _ = t => t,
  _t,
  _t2;
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { stripHTML } from '@carbon/ibmdotcom-utilities/es/utilities/stripHTML/index.js';
import { render } from 'lit/html.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
import styles from "././content-block.css.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  stablePrefix: c4dPrefix
} = settings;

/**
 * The heading content in content block.
 *
 * @element c4d-content-block-heading
 * @csspart h2 - The heading element within the content block. Usage: `c4d-content-block-heading::part(content-block-heading)`
 */
let C4DContentBlockHeading = _decorate([customElement(`${c4dPrefix}-content-block-heading`)], function (_initialize, _StableSelectorMixin) {
  class C4DContentBlockHeading extends _StableSelectorMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DContentBlockHeading,
    d: [{
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "slot",
      value() {
        return 'heading';
      }
    }, {
      kind: "field",
      decorators: [state()],
      key: "content",
      value() {
        return '';
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value:
      /**
       * The shadow slot this logo UI should be in.
       */

      function connectedCallback() {
        if (!this.hasAttribute('role')) {
          this.setAttribute('role', 'heading');
        }
        if (!this.hasAttribute('aria-level')) {
          this.setAttribute('aria-level', '2');
        }
        _superPropGet(C4DContentBlockHeading, "connectedCallback", this, 3)([]);
      }
    }, {
      kind: "method",
      key: "firstUpdated",
      value: function firstUpdated() {
        this.content = stripHTML(this.innerHTML);
        render(html(_t || (_t = _`<h2 part="h2">${0}</h2>`), this.content), this);
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        return html(_t2 || (_t2 = _` ${0} `), this.content);
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--content-block__heading`;
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value() {
        return styles;
      }
    }]
  };
}, StableSelectorMixin(LitElement));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockHeading;
//# sourceMappingURL=content-block-heading.js.map
